module.exports = __webpack_public_path__ + "officialStatic/img/solution-smart-school1.ef5ffdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-smart-school1.png
// module id = wwfN
// module chunks = 0